import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Input from './components/Input'

const propTypes = {
  type: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeholder: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  info: PropTypes.string,
  isDisabled: PropTypes.bool,
  onInputChange: PropTypes.func.isRequired,
  helpText: PropTypes.string,
  textArea: PropTypes.bool,
  maxLength: PropTypes.number,
}

const defaultProps = {
  type: 'text',
  textArea: false,
  defaultValue: '',
  placeholder: '',
  label: '',
  error: '',
  info: '',
  isDisabled: false,
  helpText: '',
}

class InputContainer extends Component {
  render() {
    return <Input {...this.props} />
  }
}

InputContainer.propTypes = propTypes
InputContainer.defaultProps = defaultProps

export default InputContainer
